/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"


import Blob from "../components/Blob"

import "../styles/reset.css"
import "../styles/style.scss"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      {/* <Header siteTitle={data.site.siteMetadata?.title || `Title`} /> */}
      <>
        <main>
      
        <Blob children={children}/>
        </main>
        <footer>
          <div className="hiddenForm" >
            <form name="contact" method="POST" data-netlify="true" netlify-honeypot="bot-field" action="/success" hidden>
              <input type="hidden" name="form-name" value="contact" />
                <input type="email" placeholder="email address" name="email"/>
              <input type="submit" value="Submit"/>
            </form>
          </div>
        </footer>
      </>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
